import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  axiosError: null,
  showErrorSummary: false,
  validationRules: null,
  validationMessages: null,
  submitRouteName: "",
  showSuccessMessage: false,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
